module.exports = __webpack_public_path__ + "static/media/logo.aa3e47be.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 25
// module chunks = 0